// ACTIVIDAD RECIENTE · CUENTAS INSTITUCIONALES (v2.19.8)
// `GET /api/actividad-reciente` es INTERNAL-ONLY en el registro de rutas (Gate D) y así se queda:
// aquí no se tocan permisos. La cuenta institucional lee EXACTAMENTE los mismos hechos por el
// read-model que sí tiene autorizado y que ya aplica su alcance: `bitacora-operativa-1`.
// Esta capa sólo TRADUCE ese contrato al que el panel ya consumía. No decide prioridad, ni estado,
// ni si un hecho generó caso: todo eso viene resuelto del backend y se copia tal cual.
export const ACTIVIDAD_LIMITE = 5;

const CERRADOS = ["cerrada", "cerrada_por_sensor"];

export function mapItemBitacora(it) {
  const esCaso = it.clase === "caso";
  return {
    id: it.id,
    origen: esCaso ? "caso" : "evento",
    tipo_evento: it.tipo,
    // La prioridad se copia; si el hecho no la tiene, se deja AUSENTE y la interfaz no la afirma.
    prioridad: it.prioridad || null,
    estado_label: it.estado_label || null,
    // Existencia de caso: la publica el read-model. Un evento con caso NO es «sin alarma».
    alarma_id: it.caso_id || null,
    persona_id: it.persona_id || null,
    persona_nombre: it.persona_nombre || it.identidad_motivo || "",
    zona_nombre: it.habitacion || "",
    sitio_nombre: it.sitio_nombre || "",
    hora_recepcion_servidor: it.hora,
    hora: it.hora,
    clasificacion: it.clasificacion || null,
    // Origen de la lectura. La bitácora NO publica si la política del evento estaba habilitada, así
    // que la interfaz no afirma nada sobre el alertamiento con esta fuente: sólo lo que consta.
    fuente: "bitacora-operativa-1",
  };
}

// Misma semántica que el panel interno: eventos informativos + casos que YA salieron de la cola
// por estar cerrados. Los casos ABIERTOS siguen arriba, en la cola, y no se duplican aquí.
export function componerActividadInstitucional({ eventos = [], casos = [] } = {}, limite = ACTIVIDAD_LIMITE) {
  const items = [
    ...eventos.filter((i) => i && i.clase === "evento"),
    ...casos.filter((i) => i && i.clase === "caso" && CERRADOS.includes(i.estado)),
  ].map(mapItemBitacora);
  items.sort((a, b) => String(b.hora || "").localeCompare(String(a.hora || "")));
  return items.slice(0, limite);
}
